export function telTest(tel) {
  var regex1 = new RegExp("^\\([0-9]{2}\\) [0-9]{4}-[0-9]{4}$");
  var regex2 = new RegExp("^\\([0-9]{2}\\) [0-9]{5}-[0-9]{4}$");
  return regex1.test(tel) || regex2.test(tel);
}
